import { IonPage } from '@ionic/react'
import { useParams } from 'react-router-dom'

import { UnitEventsView } from '@apps-common/apps/portal/pages/units/pages/manage/pages/events/components'
import { SignalRProvider } from '@apps-common/contexts/SignalrContext'

export const UnitEventsPage = () => {
  const { status, unitId } = useParams<{ status: string; unitId: string }>()

  return (
    <IonPage>
      <SignalRProvider>
        <UnitEventsView status={status} unitId={unitId} />
      </SignalRProvider>
    </IonPage>
  )
}
